module.exports = __webpack_public_path__ + "static/media/1process-working.24f69cf3.png";